@if (filteredMembers().length > 0) {
  <div class="mention-dropdown">
    @for (member of filteredMembers(); track member.id; let i = $index) {
      <button
        class="mention-item"
        [class.mention-item-active]="i === activeIndex()"
        (mousedown)="selectMember(member)"
        type="button">
        <span class="mention-name or-text-md">{{ member.name }}</span>
      </button>
    }
  </div>
}
